import React from 'react';

import ArticleIcon from '@mui/icons-material/Article';
import { useTheme } from '@mui/material/styles';
import { types } from '@sunwisesoftware/sunwise-template-core';
import {
    List,
    ListItem,
    ListItemButton,
    ListItemText,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import SideMenuCard from './SideMenuCard';

const SmartDocumentsCard = ({
    handleClickDocumentItem,
    isDisabled,
    selectedDocumentId,
    smartDocuments,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();

    if (smartDocuments?.length === 0) return <></>;

    return (
        <SideMenuCard
            icon={<ArticleIcon sx={{ color: 'primary.main' }} />}
            title={t('Document', { count: 2 })}
        >
            <List disablePadding>
                {smartDocuments.map((document) => (
                    <ListItem
                        disabled={
                            isDisabled ||
                            document.document_reference_id ===
                                selectedDocumentId
                        }
                        disablePadding
                        key={`smart-document-${document.document_reference_id}`}
                        selected={
                            document.document_reference_id ===
                            selectedDocumentId
                        }
                        sx={{
                            borderRadius: '8px',
                            mb: '5px',
                            '&.Mui-selected': {
                                backgroundColor:
                                    theme.palette.mode === 'dark'
                                        ? '#000'
                                        : 'rgba(31, 60, 83, 0.13)',
                            },
                        }}
                    >
                        <ListItemButton
                            disabled={
                                isDisabled ||
                                document.document_reference_id ===
                                    selectedDocumentId
                            }
                            onClick={() =>
                                handleClickDocumentItem({
                                    id: document.document_reference_id,
                                    name: document.name,
                                    type: types.SMART_DOCUMENTS_TYPE,
                                })
                            }
                            sx={{ borderRadius: '8px' }}
                        >
                            <ListItemText
                                primary={document.name}
                                sx={{
                                    '.MuiListItemText-primary': {
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                    },
                                }}
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </SideMenuCard>
    );
};

SmartDocumentsCard.propTypes = {
    handleClickDocumentItem: PropTypes.func,
    isDisabled: PropTypes.bool,
    selectedDocumentId: PropTypes.string,
    smartDocuments: PropTypes.array,
};

export default SmartDocumentsCard;
